import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getCMS, getSettings } from '../api';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';

const ImpressumPage = ({ user, onLogout, page = 'impressum' }) => {
  const [content, setContent] = useState(null);
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const key = page === 'datenschutz' ? 'datenschutz_text' : 'impressum_text';
    Promise.all([
      getCMS(key),
      getSettings()
    ]).then(([cmsRes, settingsRes]) => {
      setContent(cmsRes.data);
      setSettings(settingsRes.data);
    }).catch(console.error)
    .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="min-h-screen bg-[#EEF3F8]">
      <Navigation user={user} onLogout={onLogout} settings={settings} isLanding={false} />
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6 py-8 md:py-14">
        <Link to="/" className="inline-flex items-center gap-2 text-[#7A9BB5] hover:text-[#2E3A46] text-sm mb-8">
          <ArrowLeft size={16} />
          Zurück zur Startseite
        </Link>
        <div className="card-frost p-8 md:p-12">
          {loading ? (
            <div className="animate-pulse space-y-4">
              <div className="h-8 bg-[#D8E8F0] rounded w-1/3"></div>
              <div className="h-4 bg-[#D8E8F0] rounded w-full"></div>
              <div className="h-4 bg-[#D8E8F0] rounded w-2/3"></div>
            </div>
          ) : (
            <div className="cms-content" dangerouslySetInnerHTML={{ __html: content?.body || '<p>Inhalt wird geladen...</p>' }} />
          )}
        </div>
      </div>
      <Footer settings={settings} />
    </div>
  );
};

export default ImpressumPage;
